import React from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import { privateRoutes, publickRoutNames } from "router";
import OAuthService from "services/OAuthService";
import PageWrapper from "./PageWrapper";
import styles from "./PageWrapper.module.scss";


function AppRouterPrivate({ children }) {
  const auth = true
  const userInfo = OAuthService.decryptedSync('userData')

  if (!auth) {
    return <Navigate to={publickRoutNames.mainInfo} state={{ auth: true }} />
  }


  return (
    <PageWrapper className={styles.mainPageWrapper}>
      <Routes>
        {
          ((userInfo?.part?.id) || userInfo?.superUser === true) &&
          privateRoutes.map(rout => <Route path={rout.path} element={<rout.component />} key={rout.path} />)
        }
        <Route path="*" element={<Navigate to="/nofound" />} />
      </Routes>
    </PageWrapper>
  )
}

export default AppRouterPrivate;